import React, { useEffect } from "react";
import styles from "./PopupModal.module.css";

const PopupModal = ({
  open,
  title = "Success",
  message = "",
  onClose,
  onOk,
  wide = false,
  render = false,
  renderData,
}) => {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        onOk ? onOk() : onClose?.();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onOk, onClose]);

  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={`${styles.modal} ${wide ? styles.modalWide : ""}`}>
        {/* Header row with title and optional close X (only in render mode) */}
        {render ? (
          <div className={styles.header}>
            {title && <h3 className={styles.title}>{title}</h3>}
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>
        ) : (
          title && <h3 className={styles.title}>{title}</h3>
        )}

        {render ? (
          <div
            className={`${styles.renderContent} ${
              wide ? styles.messageWide : ""
            }`}
          >
            {typeof renderData === "function" ? renderData() : renderData}
          </div>
        ) : (
          <p className={`${styles.message} ${wide ? styles.messageWide : ""}`}>
            {message}
          </p>
        )}

        {/* OK button only for non-render mode */}
        {!render && (
          <div className={styles.buttonWrapper}>
            <button className={styles.okButton} onClick={onOk || onClose}>
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupModal;